import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Typography, Button } from '@mui/material';
import { useOidc } from '@nohara-dxdev/react-oidc';
import { useTranslation } from 'react-i18next';

const AccessDeniedRoute = () => {
  const { t } = useTranslation();
  const { logout } = useOidc();

  return (
    <Box
      sx={{
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontWeight: 600,
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h4" component="h1" gutterBottom>
        {t('accessDenied.title')}
      </Typography>
      <Typography variant="body1" gutterBottom color="text.secondary">
        {t('accessDenied.description')}
      </Typography>
      <Button onClick={() => void logout()} variant="contained" color="primary" sx={{ mt: 2 }}>
        {t('accessDenied.logout')}
      </Button>
    </Box>
  );
};

export default AccessDeniedRoute;
